.atm_vy_1osqo2v{width:100%;}
.atm_9s_1txwivl{display:flex;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_ar_1bp4okc.atm_ar_1bp4okc{flex-direction:column;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_r3_1h6ojuz{text-align:center;}
.atm_gi_1wugsn5{margin:auto;}
.atm_l8_ftgil2{padding:8px;}
.atm_l8_exct8b{padding:16px;}
.atm_gi_1wz0xz0{margin:24px auto;}
.atm_ge_glywfm.atm_ge_glywfm{list-style-type:none;}
